'use client';

import { c as _c } from "react/compiler-runtime";
import { VerticalTabs } from '@cc-shopping/ui/composites/VerticalTabs';
import { Box, type BoxProps, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { getMappedColor } from '../../utils';
import type { LeftNavTabProps } from './types';
export type LeftNavDesktopTabsProps = {
  ordered: boolean | null;
  showDivider?: boolean | null;
  tabProps?: LeftNavTabProps;
  labels: string[];
  renderedContents: ReactNode[];
  renderedImages: (ReactNode | null)[];
};
export const LeftNavDesktopTabs = t0 => {
  const $ = _c(36);
  const {
    ordered,
    showDivider,
    tabProps,
    labels,
    renderedContents,
    renderedImages
  } = t0;
  const variant = tabProps?.variant ?? "default";
  const t1 = tabProps?.activeTabColor;
  let t2;
  if ($[0] !== t1) {
    t2 = getMappedColor(t1, "yellows.lighter-2");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const activeTabColor = t2;
  const t3 = tabProps?.activeTabHoverColor;
  let t4;
  if ($[2] !== t3) {
    t4 = getMappedColor(t3, "yellows.light");
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const activeTabHoverColor = t4;
  let t5;
  if ($[4] !== labels || $[5] !== ordered || $[6] !== variant) {
    let t6;
    if ($[8] !== ordered || $[9] !== variant) {
      t6 = (label, index) => ({
        title: label,
        ordered,
        index,
        variant
      });
      $[8] = ordered;
      $[9] = variant;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = labels.map(t6);
    $[4] = labels;
    $[5] = ordered;
    $[6] = variant;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[11] !== renderedContents || $[12] !== renderedImages) {
    let t7;
    if ($[14] !== renderedImages) {
      t7 = (content, index_0) => ({
        renderedContent: content,
        renderedImage: renderedImages[index_0]
      });
      $[14] = renderedImages;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = renderedContents.map(t7);
    $[11] = renderedContents;
    $[12] = renderedImages;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = variant === "condensed" ? 0 : 3;
  let t8;
  if ($[16] !== showDivider) {
    t8 = showDivider ? {
      gap: 3
    } : {};
    $[16] = showDivider;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      "data-testid": "credit-cards-left-nav-desktop",
      sx: {
        paddingY: t7,
        ...t8
      }
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = t9 as BoxProps & {
    'data-testid': string;
  };
  let t11;
  if ($[21] !== activeTabColor || $[22] !== activeTabHoverColor || $[23] !== variant) {
    t11 = {
      activeTabColor,
      activeTabHoverColor,
      variant
    };
    $[21] = activeTabColor;
    $[22] = activeTabHoverColor;
    $[23] = variant;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== variant) {
    t12 = {
      sx: {
        ...(variant === "condensed" ? {
          width: "200px"
        } : {})
      }
    };
    $[25] = variant;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== showDivider) {
    t13 = {
      sx: {
        paddingY: 0,
        ...(showDivider ? {
          borderRight: "1px solid",
          borderColor: "neutral.lighter",
          paddingRight: 3
        } : {})
      }
    };
    $[27] = showDivider;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t5 || $[34] !== t6) {
    t14 = <VerticalTabs labelProps={t5} LabelComponent={LabelComponent} contentProps={t6} ContentComponent={ContentComponent} containerProps={t10} tabProps={t11} listItemProps={t12} tabListProps={t13} />;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t5;
    $[34] = t6;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
const LabelComponent = t0 => {
  const $ = _c(10);
  const {
    title,
    ordered,
    index,
    variant
  } = t0;
  const typographyVariant = variant === "condensed" ? "bodySmall" : "smallHeadline";
  let t1;
  if ($[0] !== index || $[1] !== ordered || $[2] !== typographyVariant) {
    t1 = ordered && <Box sx={{
      backgroundColor: "yellows.lighter",
      minWidth: "35px",
      minHeight: "35px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}><Typography variant={typographyVariant}>{index + 1}</Typography></Box>;
    $[0] = index;
    $[1] = ordered;
    $[2] = typographyVariant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== title || $[5] !== typographyVariant) {
    t2 = <Typography variant={typographyVariant}>{title}</Typography>;
    $[4] = title;
    $[5] = typographyVariant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
const ContentComponent = t0 => {
  const $ = _c(9);
  const {
    renderedContent,
    renderedImage
  } = t0;
  if (renderedImage) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        display: "flex",
        flexDirection: "row",
        gap: 3,
        height: "100%"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== renderedContent) {
      t2 = <div>{renderedContent}</div>;
      $[1] = renderedContent;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        display: {
          xs: "none",
          md: "flex"
        },
        justifyContent: "center",
        alignItems: "center"
      };
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== renderedImage) {
      t4 = <Box sx={t3}>{renderedImage}</Box>;
      $[4] = renderedImage;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
      t5 = <Box sx={t1}>{t2}{t4}</Box>;
      $[6] = t2;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  return renderedContent;
};